import React from 'react';
import { Button } from '../ui/button';

/**
 * Footer of the mobile drawer — handles the auth CTA cluster so the
 * parent can stay declarative.
 */
const MobileAuthControls = ({
  user,
  isPro,
  loading,
  onLogout,
  onGoToAuth,
  onClose,
}) => {
  if (loading) return null;
  const wrap = (fn) => () => {
    onClose();
    fn();
  };

  if (!user) {
    return (
      <Button
        className="w-full bg-gradient-to-r from-cyan-500 to-violet-500 hover:from-cyan-400 hover:to-violet-400 text-white shadow-[0_0_18px_rgba(139,92,246,0.4)]"
        onClick={wrap(onGoToAuth)}
        data-testid="mnav-signin-btn"
      >
        Sign in / Sign up
      </Button>
    );
  }
  return (
    <>
      <div className="text-xs text-white/60 px-2">
        <p className="truncate">{user.email}</p>
        <p className="text-cyan-300 font-semibold">{isPro ? 'Pro' : 'Free'} Plan</p>
      </div>
      <Button
        className="w-full bg-white/10 hover:bg-white/20 text-white"
        onClick={wrap(onLogout)}
        data-testid="mnav-logout-btn"
      >
        Logout
      </Button>
    </>
  );
};

export default MobileAuthControls;
